import { GoogleAnalyticsConfigurationApiClient } from '@fourthwall/services/dist/GoogleAnalyticsConfigurationApiClient';
import { createQueryHook } from '@fourthwall/utils';
export const useGoogleAnalyticsConfigurationQuery = createQueryHook(GoogleAnalyticsConfigurationApiClient.getConfiguration, { queryKey: ['googleAnalyticsConfiguration'] });
